import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ControlsFinderComponent } from './controls-finder/controls-finder.component';

@NgModule({
  declarations: [
    ControlsFinderComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    ControlsFinderComponent,
  ],
})
export class ControlsModule { }
